import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

// Own constants/actions/components
import { getReviveAction } from 'services/actions/revive-experiences';
import { results, resultsItems } from 'services/selectors/revive';
import CardInfo from 'components/cards';
import LoaderCP from 'components/loader';

const ExperienciesInspireSection = (props) => {
  const dispatch = useDispatch();
  const data = useSelector(results);
  const itemsResults = useSelector(resultsItems);

  useEffect(() => {
    dispatch(getReviveAction(props.maxResults));
  }, []);

  const renderBody = () => {
    const { page } = props;

    return (
      <Container>
        <Row className="py-60">
          <Col lg={12}>
            <h2 className="text-center text-midnight-blue ft-28">Revive Experiencias</h2>
          </Col>
          {
            itemsResults.data.map((r) => {
              return (
                <Col lg={4} key={r.id}>
                  <Link to={`/revive-experiencias${r.pathName}/${r.id}`} className="not-link">
                    <CardInfo
                      inspire
                      image={r.imageUrl}
                      title={r.title}
                      bodyText={r.shortDescription} />
                  </Link>
                </Col>
              );
            })
          }
          {
            page === 'show' ? ''
              : (
                <Col lg={12} className="text-center">
                  <Link to="/revive-experiencias" className="btn btn-primary my-15">Ver más</Link>
                </Col>
              )
          }
        </Row>
      </Container>
    );
  };

  return (
    <Container fluid>
      { data.isFetching ? <LoaderCP /> : '' }
      { data.error ? '' : '' }
      { itemsResults && itemsResults.data && data.isFetching === false
        ? renderBody()
        : '' }
    </Container>
  );
};

ExperienciesInspireSection.defaultProps = {
  page: '',
  maxResults: null,
};

ExperienciesInspireSection.propTypes = {
  page: PropTypes.string,
  maxResults: PropTypes.number,
};

export default ExperienciesInspireSection;
